module.exports = __webpack_public_path__ + "static/media/briefcase.09dc1df8.svg";